import { render, staticRenderFns } from "./reference-view.vue?vue&type=template&id=2984aa8f"
import script from "./reference-view.vue?vue&type=script&lang=js"
export * from "./reference-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports